"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Checkbox = function Checkbox(_a) {
  var className = _a.className,
      isCheckbox = _a.isCheckbox,
      isDisabled = _a.isDisabled,
      label = _a.label,
      defaultValue = _a.defaultValue,
      _onChange = _a.onChange;
  className = className || "";
  var type = isCheckbox ? "checkbox" : "switch";
  var inputClass = isCheckbox ? "checkbox__box" : "switch__toggle";
  var labelClass = isCheckbox ? "checkbox__label" : "switch__label";
  var uniqueId = type + "--" + (Math.random() * 100000000).toFixed(0);
  return react_1["default"].createElement("div", {
    className: type + " " + className
  }, react_1["default"].createElement("input", {
    defaultChecked: defaultValue,
    onChange: function onChange(event) {
      return _onChange && _onChange(event.target.checked, event);
    },
    className: inputClass,
    type: "checkbox",
    id: uniqueId,
    disabled: isDisabled
  }), react_1["default"].createElement("label", {
    className: labelClass,
    htmlFor: uniqueId
  }, label));
};

exports["default"] = Checkbox;